import React from "react";
import styles from "./PendingPaymentCard.module.scss";
import { ReactComponent as PaymentPendingIcon } from "../../assets/images/payment-pending.svg";
import NewPaymentPendingIcon from "../../assets/images/Frame 1000004465.png";
import { useHistory } from "react-router-dom";

type PendingPaymentCardProps = {
  paymentmethod: string;
};
const PendingPaymentCard = ({ paymentmethod }: PendingPaymentCardProps) => {

  const history = useHistory();

  // Handler to navigate to the home page
  const handleClose = () => {
    // history.push("/"); // Redirect to home page
    window.location.reload() //refresh page
  };
  
  return (
    <div className={styles.pending_transaction}>
      {/* <PaymentPendingIcon /> */}
      <img src={NewPaymentPendingIcon} />
      <h3>Payment Pending</h3>
      <p style={{margin:'20px 0px' }}>
        A mail will be sent to you once your transaction is confirmed.
      </p>
      <button onClick={handleClose} style={{padding:'8px',marginTop:'30px' ,width:'193px', border:'none',color:'white',borderRadius:'6px' ,background:'#8E183E'}}>Close</button>
    </div>
  );
};

export default PendingPaymentCard;
